module.exports = __webpack_public_path__ + "images/marketing/features/accel3.jpg";